export const LIST_PAGE_SIZE_DEFAULT = 10

export function normalizePagination(pagination, page, limit) {
  const pageSize = pagination?.pageSize ?? pagination?.itemsPerPage ?? limit
  const totalItems =
    pagination?.totalItems ?? pagination?.total ?? pagination?.count ?? 0
  const totalPages =
    pagination?.totalPages ??
    Math.max(1, Math.ceil(totalItems / pageSize) || 1)
  const currentPage = Math.min(
    pagination?.currentPage ?? page,
    totalPages,
  )

  return {
    currentPage,
    pageSize,
    totalItems,
    total: totalItems,
    totalPages,
    hasNextPage: pagination?.hasNextPage ?? currentPage < totalPages,
    hasPreviousPage: pagination?.hasPreviousPage ?? currentPage > 1,
  }
}

export function parsePaginatedListResponse(raw, { page = 1, limit = 10, mapRow = (r) => r } = {}) {
  const rows = Array.isArray(raw?.data)
    ? raw.data
    : Array.isArray(raw)
      ? raw
      : []

  const pagination = raw?.pagination
    ? normalizePagination(raw.pagination, page, limit)
    : normalizePagination(
        { totalItems: rows.length, currentPage: 1, pageSize: limit },
        page,
        limit,
      )

  return {
    data: rows.map(mapRow),
    pagination,
    summary: raw?.summary ?? null,
  }
}

export function getPaginatedListMeta(listResult) {
  const pagination = listResult?.pagination
  const totalItems = pagination?.totalItems ?? 0
  return {
    items: listResult?.data ?? [],
    totalItems,
    totalPages: pagination?.totalPages ?? 1,
    showPagination: totalItems >= 10,
  }
}
